var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "led",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" Vertical farm facility ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("With a wide range of wavelength and spectrum, the system saves energy and enables the most efficient agricultural activities by adjusting the LED lighting depending on the crop growth stage.")];
      },
      proxy: true
    }])
  }, [_vm._v(" High-efficiency artificial smart control that replaces sunlight "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('b', [_vm._v("LED Lighting System")])])], 1), _c('page-section', {
    staticClass: "page-section--last grey lighten-5"
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 456,
            "src": "/images/sub/solution/plant/led-img.jpg"
          }
        })], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', [_vm._v(" LED Lighting System ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Features of LED")];
            },
            proxy: true
          }])
        }, [_vm._v(" You can control the growth period and conditions of crops by providing proper amounts of light through efficient light control including intensity, quantity, and saturation. ")]), _c('div', {
          staticClass: "mt-16px mt-md-24px"
        }, [_c('v-card', {
          staticClass: "rounded-tl-xl rounded-br-xl d-inline-block",
          attrs: {
            "outlined": "",
            "tile": ""
          }
        }, [_c('v-img', {
          attrs: {
            "width": "126",
            "aspect-ratio": 126 / 102,
            "src": "/images/sub/solution/plant/led-img2.jpg"
          }
        })], 1)], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          staticClass: "d-flex align-center justify-center",
          attrs: {
            "outlined": "",
            "rounded": "",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('div', {
          staticClass: "w-100 py-sm-20px py-lg-40px py-xl-100px"
        }, [_c('v-row', {
          attrs: {
            "no-gutters": "",
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "lg": "auto"
          }
        }, [_c('div', {
          staticClass: "px-10px py-30px px-xl-50px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "width": _vm.$vuetify.breakpoint.lgAndUp ? 482 : '100%',
            "aspect-ratio": 482 / 494,
            "src": "/images/sub/solution/plant/led-img3.png"
          }
        }), _c('div', {
          staticClass: "mt-14px mt-md-20px text-center"
        }, [_c('p', {
          staticClass: "txt txt--lg txt--dark"
        }, [_vm._v("The smart irrigation system allows remote monitoring and control, "), _c('br', {
          staticClass: "d-none d-md-block"
        }), _vm._v("which enhances convenience and efficiency in plant cultivation.")])])], 1)]), _c('v-col', {
          staticClass: "d-none d-lg-block align-self-stretch ml-n1px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-divider', {
          staticClass: "h-100",
          attrs: {
            "vertical": ""
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "lg": "auto"
          }
        }, [_c('div', {
          staticClass: "px-10px py-20px px-xl-50px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "width": _vm.$vuetify.breakpoint.lgAndUp ? 404 : '100%',
            "aspect-ratio": 404 / 442,
            "src": "/images/sub/solution/plant/led-img4-en.png"
          }
        })], 1)])], 1)], 1)])];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/plant/led-img5.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Lighting Apparatus for Plant Cultivation ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered Patent ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }